import React, { useEffect, useState } from "react";

const CtaSection = ({ onStartFreeTrial }) => {
  const [sessionID, setSessionId] = useState("");
  const [campaignIdHook, setCampaignIdHook] = useState("");

  const generateUUID = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16),
    );

  useEffect(() => {
    const storedSessionID = sessionStorage.getItem("sessionID");

    if (storedSessionID) {
      setSessionId(storedSessionID);
    } else {
      const newSessionID = generateUUID();

      sessionStorage.setItem("sessionID", newSessionID);
      setSessionId(newSessionID);
    }
  }, []);

  useEffect(() => {
    let urlParams = new URLSearchParams(window.location.search);
    let campaignid = urlParams.get("campaignid");

    if (!campaignid) {
      urlParams = new URLSearchParams(window.location.hash.substring(1));
      campaignid = urlParams.get("campaignid");
    }

    if (campaignid) {
      sessionStorage.setItem("campaignId", campaignid);
      setCampaignIdHook(campaignid);
    }
  }, []);

  return (
    <div className="px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <div className="mx-auto w-full max-w-5xl rounded-xl border border-[#01c378] bg-[#e6f9f0] p-6 sm:p-8 md:p-10">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <div className="flex-1">
            <h2 className="montserrat-font-1 text-2xl font-bold leading-tight text-[#004d40] sm:text-3xl lg:text-4xl">
              Start optimizing your business with Anlook today
            </h2>
          </div>

          <div className="w-full md:w-auto">
            <button
              type="button"
              onClick={onStartFreeTrial}
              className="montserrat-font-2 block w-full rounded-lg bg-[#01c378] py-3 text-center text-base font-medium text-white transition-colors hover:bg-[#00b36e] md:w-[170px]"
            >
              Start Free Trial
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;